module.exports = __webpack_public_path__ + "img/86.22b23f5f.jpg";